module.exports = __webpack_public_path__ + "img/product-showcase-gallery-03.c5ff1ed0.jpg";